import { render, staticRenderFns } from "./GartnerWidgetBlock.vue?vue&type=template&id=584ea434"
import script from "./GartnerWidgetBlock.vue?vue&type=script&lang=js"
export * from "./GartnerWidgetBlock.vue?vue&type=script&lang=js"
import style0 from "./GartnerWidgetBlock.vue?vue&type=style&index=0&id=584ea434&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports